<template>
  <!-- 退款列表 -->
  <div class='refund-list'>
    <sub-nav :navs='navs' />
    <h2>退款列表</h2>
    <div class='content'>
      <!-- 列表 -->
      <div class='table-wrapper' >
        <table v-loading='loading' class='table'>
          <thead>
            <tr>
              <td v-for='item in tableItems' :key='item.idx' :style='{width:item.width}'>{{ item.label }}</td>
            </tr>
          </thead>
          <tbody v-if='list.length'>
            <tr v-for='item in list' :key='item.idx'>
              <td v-for='t in tableItems' :key='t.idx' :style='{width:item.width}'>
                <div v-if='t.props === "voucher_path"' class='cell'>
                  <a v-if='item.voucher_path' :href='item.voucher_path' target='blank'>点击查看</a>
                </div>
                <div v-else-if='t.props === "check"' class='cell'>
                  <a href='javascript:;' class='btn-approve' @click='check("APPROVE",item)'>同意</a>
                  <a href='javascript:;' class='btn-reject' @click='check("REJECT",item)'>拒绝</a>
                </div>
                <div v-else class='cell'>{{ item[t.props] | propsFilter(t.props) }}</div>
              </td>
            </tr>
          </tbody>
          <p v-else class='no-data'>无数据</p>
        </table>
      </div>
      <page :total='total' @change='changePage'/>
      <a href='javascript:;' class='btn-back' @click='goBack'>返回</a>
    </div>
  </div>
</template>

<script>
import Page from '@/components/Page'
import SubNav from '@/components/SubNav'

import { REFUND_LIST, CHECK_REFUND_APPLY } from '@/api'

export default {
  components: {
    Page,
    SubNav
  },

  filters: {
    propsFilter(val,props) {
      let result
      switch (props) {
        case 'money':
          result = '￥' + val
          break
        case 'voucher_path':
          result = val
          break
        default:
          result = val
          break    
      }
      return result
    }
  },
  data() {
    return {
      loading: false,
      page: 1,
      total: 0,
      list: [],
      navs: [{label: '个人中心', path: '/my'}],
      tableItems: [
        { idx: 1, label: '序号', props: 'idx', width: '50px'},
        { idx: 2, label: '学校', props: 'school', width: '100px'},
        { idx: 3, label: '院系', props: 'department', width: '120px'},
        { idx: 4, label: '年级专业班级', props: 'profession_class',width: '120px'},
        { idx: 7, label: '批发单号', props: 'wholesale_no', width: '120px'},
        { idx: 8, label: '书号', props: 'book_no', width: '150px'},
        { idx: 9, label: '索引', props: 'indexes',width: '60px'},
        { idx: 10, label: '书名', props: 'book_name',width: '150px'},
        { idx: 11, label: '退款金额', props: 'money',width: '80px'},
        { idx: 12, label: '退还数量', props: 'num',width: '60px'},
        { idx: 13, label: '申请日期', props: 'gmt_modified',width: '150px'},
        { idx: 14, label: '退款凭证', props: 'voucher_path',width: '120px'},
        { idx: 15, label: '退款原因', props: 'description',width: '200px'},
        { idx: 16, label: '审核', props: 'check',width: '150px'},
      ]
    }
  },
  created() {
    this.setActiveBar('MY')
    this.getList()
  },

  methods: {
    // 审核
    check(type,item) {
      let para = {
        refund_no: item.refund_no,
        status: type === 'APPROVE' ? 1 : 2       // 1：通过 2;拒绝
      }
      this.loading = true
      CHECK_REFUND_APPLY(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.$notify()
          this.getList()
        } else {
          this.$notify(res.data.msg,'error')
        }
      })
    },

    // 翻页
    changePage(val) {
      this.page = val
    },

    // 获取列表
    getList() {
      let para = {
        page: this.page
      }
      this.loading = true
      REFUND_LIST(para).then(res=>{
        this.loading = false
        if (res.data.code === 0) {
          this.total = res.data.total
          this._formatList(res.data.data)
        }
      })
    },

    // 格式化列表
    _formatList(data) {
      this.list = []
      data.forEach((e,idx)=>{
        e.idx = idx + 1
        this.list.push(e)
      })
    }

  },

}
</script>

<style lang="less" scoped>
@import "../assets/css/mixin.less";
.refund-list {
  width: 1200px;

  h2 {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }

  .content {
    width: 1200px;
    margin-top: 30px;

    .table-wrapper {
      width: 1200px;
      overflow-x: scroll;
      border: 1px solid #999;

      // 列表
      .table {
        width: 1500px;
        table-layout: fixed;
        font-size: 14px;
        text-align: center;
        position: relative;

        tbody,
        thead {
          td {
            height: 40px;
            vertical-align: middle;
            box-sizing: border-box;
            border-bottom: 1px solid #dddddd;
            border-right: 1px solid #dddddd;
          }
        }

        thead td {
          background-color: @blue-d;
          color: #ffffff;
        }
        tbody {
          tr:nth-of-type(even) {
            background-color: @blue-l;
          }

          td {
            color: #4d4d4d;
          }

          a {
            font-size: 12px;
            color: @blue-d;
            display: inline-block;
            width: 84px;
            height: 25px;
            line-height: 25px;
            border: 1px solid #ddd;
            border-radius: 5px;
            text-align: center;
            background: #ffffff;

            &.btn-approve {
              width: 55px;
              color: #ffffff;
              background-color: #00c36b;
              border: none;
              margin-right: 5px;
            }

            &.btn-reject {
              width: 55px;
              color: #ffffff;
              background-color: #ff6565;
              border: none;
            }
          }
        }

        .no-data {
          height: 50px;
          line-height: 50px;
          color: #999999;
          font-size: 20px;
          text-align: center;
          width: 1590px;
          background-color: #f0f0f0;
        }
      }
    }

    .btn-back {
      display: block;
      margin: 50px auto 20px;
      width: 298px;
      height: 38px;
      border-radius: 5px;
      line-height: 38px;
      text-align: center;
      background-color: @blue-d;
      color: #ffffff;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/pages/RefundList.vue